// Undo/redo stack for X-axis zoom ranges. `null` means the full data range.

export const createZoomHistory = () => {
  let past = [];
  let current = null;
  let future = [];

  return {
    get current() {
      return current;
    },
    canBack: () => past.length > 0,
    canForward: () => future.length > 0,
    push(range) {
      past.push(current);
      current = range;
      future = [];
      return current;
    },
    back() {
      if (!past.length) return current;
      future.push(current);
      current = past.pop();
      return current;
    },
    forward() {
      if (!future.length) return current;
      past.push(current);
      current = future.pop();
      return current;
    },
    reset() {
      if (current !== null) {
        past.push(current);
        current = null;
        future = [];
      }
      return current;
    },
  };
};
